import React from 'react';

type Language = 'en' | 'es';

interface Translations {
  languageLabel: string;
  surveyTitle: string;
  surveyDescription: string;
}

interface TranslationsMap {
  en: Translations;
  es: Translations;
}

const translations: TranslationsMap = {
  en: {
    languageLabel: 'Language / Idioma:',
    surveyTitle: 'Environment Management Experience',
    surveyDescription: 'Share your experience managing production and non-production environments, including the tooling, friction points, and improvements that matter most in your work.',
  },
  es: {
    languageLabel: 'Idioma / Language:',
    surveyTitle: 'Experiencia en la Gestión de Entornos',
    surveyDescription: 'Comparte tu experiencia gestionando entornos de producción y no producción, incluidas las herramientas, los puntos de fricción y las mejoras que más importan en tu trabajo.',
  },
};

interface HeaderComponentProps {
  language: Language;
  onLanguageChange: (e: React.ChangeEvent<HTMLSelectElement>) => void;
  progress: number | null;
  isCompact: boolean;
  position?: React.CSSProperties['position'];
}

function HeaderComponent({ language, onLanguageChange, progress, isCompact, position }: HeaderComponentProps): React.ReactElement {
  const t = translations[language];

  return (
    <header id="header" className={`header${isCompact ? ' header--compact' : ''}`} style={{ position }}>
      <div className="header__container">
        {isCompact ? (
          <div className="header__top-row">
            <div className="header__top-title sd-title sd-container-modern__title">
              <div className="sd-header__text">
                <div className="sd-title" aria-label={t.surveyTitle}>
                  <span className="sv-string-viewer">{t.surveyTitle}</span>
                </div>
              </div>
              <div className="sd-hidden"></div>
            </div>

            <div className="language-selector language-selector--compact">
              <div className="language-selector__compact-shell">
                <select
                  value={language}
                  onChange={onLanguageChange}
                  className="language-selector__select language-selector__select--compact"
                  aria-label={t.languageLabel}
                >
                  <option value="en">EN</option>
                  <option value="es">ES</option>
                </select>
                <span className="language-selector__arrow" aria-hidden="true">▾</span>
              </div>
            </div>
          </div>
        ) : (
          <>
            <div className="language-selector">
              <label className="language-selector__label">
                {t.languageLabel}
              </label>
              <select
                value={language}
                onChange={onLanguageChange}
                className="language-selector__select"
                aria-label={t.languageLabel}
              >
                <option value="en">English</option>
                <option value="es">Español</option>
              </select>
            </div>
            <div className="sd-title sd-container-modern__title">
              <div className="sd-header__text">
                <div className="sd-title" aria-label={t.surveyTitle}>
                  <span className="sv-string-viewer">{t.surveyTitle}</span>
                </div>
                <div className="sd-description">
                  <span className="sv-string-viewer sv-string-viewer--multiline">
                    {t.surveyDescription}
                  </span>
                </div>
              </div>
              <div className="sd-hidden"></div>
            </div>
          </>
        )}
      </div>
      {typeof progress === 'number' && (
        <div className="survey-progress">
          <div className="survey-progress__bar">
            <div
              className="survey-progress__fill"
              style={{ width: `${progress}%` }}
            />
          </div>
          <span className="survey-progress__text">{Math.round(progress)}%</span>
        </div>
      )}
    </header>
  );
}

export default HeaderComponent;
